import api from '../../utils/api';

export const removePointOfInterest = (id: number) => api.delete({ url: `/point-of-interest/${id}` });
